import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseIntegrationDisconnected } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventIntegrationDisconnected = () => {
  const { websocket, integrationsStore, configStore } = useEntitiesContext()
  const handler = (data: IResponseIntegrationDisconnected) => {
    integrationsStore.syncUserIntegration(data.userIntegration)

    if (data.notifyUser) {
      configStore.setIntegrationDisconnected(true)
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationDisconnected, handler), [])
}
